import { makeRequest } from 'utils/requestLogger';

export default (roundtable) =>
  makeRequest('post', '/api/universe/roundtables', roundtable);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/createPremade.js